export default __webpack_public_path__ + "static/media/collections_icon.863025da.svg";